const textSecondary = "#787174";
const textOnColorSecondary = "#ffffffcc";
const iconOnColorSubtle = "#ffffff99";
const basePrimaryGrey90 = "#1f1d1e";
const basePrimaryGrey80 = "#3d3a3b";
const basePrimaryGrey60 = "#7a7376";
const basePrimaryGrey50 = "#999094";
const basePrimaryGrey35 = "#b8b1b4";
const basePrimaryGrey25 = "#ccc8ca";
const basePrimaryGrey15 = "#e0dedf";
const basePrimaryGrey10 = "#eeeced";
const basePrimaryGrey5 = "#f5f4f4";
const basePrimaryGrey1 = "#fafafa";
const basePrimaryGreyWhite = "#ffffff";
const basePrimaryPurple100 = "#6a266d";
const basePrimaryPurple90 = "#79347f";
const basePrimaryPurple70 = "#9751a2";
const basePrimaryPurple50 = "#b56dc6";
const basePrimaryPurple20 = "#ebd3f1";
const baseSecondarySalmon100 = "#e66442";
const baseSecondarySalmon50 = "#ff6f49";
const baseSecondarySalmon20 = "#ffdad3";
const baseSecondarySalmon10 = "#fff5f5";
const baseSecondaryMustard100 = "#997d00";
const baseSecondaryMustard50 = "#f2ca1b";
const baseSecondaryMustard20 = "#faecad";
const baseSecondaryMustard10 = "#fff8d9";
const basePrimaryPurple10 = "#fdf5ff";
const basePrimaryGreen100 = "#0e9976";
const basePrimaryGreen50 = "#59c1a7";
const bgOverlayOverlayModal = "#18041c54";
const basePrimaryGreen20 = "#caf3e7";
const bgOverlayOverlayLightbox = "#1f1d1e99";
const bgOverlayOverlayTakeover = "#18041c1f";
const basePrimaryGreen10 = "#e6fff7";
const basePrimaryRed100 = "#bf3144";
const basePrimaryRed50 = "#ef3d55";
const basePrimaryRed20 = "#fbc3cb";
const basePrimaryRed10 = "#fee5e9";
const basePrimaryCyan100 = "#2489a9";
const basePrimaryCyan50 = "#34c3f2";
const basePrimaryCyan20 = "#c2f0fc";
const basePrimaryCyan10 = "#e6fbff";
const basePrimaryGreyBlack = "#000000";
const basePrimaryGreyTransparent = "#00000000";
const baseTertiaryMidnight100 = "#0b3251";
const baseTertiaryOcean100 = "#0b4d54";
const baseTertiaryForest100 = "#10594b";
const baseTertiarySeabreeze100 = "#1bc9c9";
const baseTertiaryLime100 = "#c8ed77";
const baseTertiaryLemon100 = "#f4ef4d";
const baseTertiaryTangerine100 = "#f79219";
const baseTertiaryFlamingo100 = "#ff4d80";
const baseTertiaryCottoncandy100 = "#fcacd1";
const baseTertiaryWarning100 = "#bd5b00";
const baseTertiaryLavenderlighten40 = "#dfcfeb";
const baseTertiaryLavenderlighten100 = "#f8f5fb";
const baseTertiaryViolet80 = "#5156ba";
const dataVizGreen90 = "#1da180";
const dataVizRed60 = "#e53b52";
const dataVizCyan80 = "#2aa0c6";
const dataVizSalmon80 = "#f06845";
const dataVizOcean80 = "#11747e";
const dataVizViolet80 = "#5156ba";
const dataVizForest90 = "#126354";
const dataVizCognac80 = "#cc7614";
const dataVizMidnight80 = "#0d3d63";
const dataVizPurple60 = "#a65fb4";
const borderOutlinedark = "#00000014";
const borderOutlinelight = "#ffffff14";
const bgOverlayDarkoverlay = "#000000b8";
const textPrimary = basePrimaryGrey80;
const textDisabled = basePrimaryGrey50;
const textOnColor = basePrimaryGreyWhite;
const textInteractive = basePrimaryPurple70;
const textInteractiveHover = basePrimaryPurple100;
const textLink = basePrimaryPurple90;
const textDestructive = basePrimaryRed100;
const textSuccess = basePrimaryGreen100;
const textWarning = baseTertiaryWarning100;
const textInfo = basePrimaryCyan100;
const iconPrimary = textSecondary;
const iconPrimaryHover = basePrimaryGrey80;
const iconSubtle = basePrimaryGrey50;
const iconDisabled = basePrimaryGrey50;
const iconEmphasis = basePrimaryGrey80;
const iconOnColor = basePrimaryGreyWhite;
const iconInteractive = basePrimaryPurple70;
const iconInteractiveHover = basePrimaryPurple90;
const iconInteractiveSubtle = basePrimaryPurple50;
const iconDestructive = basePrimaryRed100;
const iconSuccess = basePrimaryGreen100;
const iconWarning = baseTertiaryWarning100;
const iconInfo = basePrimaryCyan100;
const iconFolder = basePrimaryCyan50;
const borderPrimary = basePrimaryGrey15;
const borderPrimarySubtle = basePrimaryGrey10;
const borderStrong = basePrimaryGrey25;
const borderEmphasis = basePrimaryGrey50;
const borderDark = basePrimaryGrey80;
const borderOnColor = basePrimaryGreyWhite;
const borderInteractive = basePrimaryPurple50;
const borderInteractiveSubtle = basePrimaryPurple20;
const borderInteractiveStrong = basePrimaryPurple100;
const borderDestructive = basePrimaryRed100;
const borderDestructiveSubtle = basePrimaryRed20;
const borderSuccess = basePrimaryGreen100;
const borderSuccessSubtle = basePrimaryGreen20;
const borderWarning = baseTertiaryWarning100;
const borderWarningSubtle = baseSecondarySalmon20;
const borderInfo = basePrimaryCyan100;
const borderInfoSubtle = basePrimaryCyan20;
const bgPrimary = basePrimaryGreyWhite;
const bgPrimaryHover = basePrimaryGrey5;
const bgSecondary = basePrimaryGrey1;
const bgSecondaryHover = basePrimaryGrey10;
const bgTertiary = basePrimaryGrey5;
const bgTertiaryHover = basePrimaryGrey15;
const bgEmphasis = basePrimaryGrey15;
const bgDisabled = basePrimaryGrey5;
const bgDisabledStrong = basePrimaryGrey35;
const bgStrong = basePrimaryGrey35;
const bgStronghover = basePrimaryGrey50;
const bgInteractive = basePrimaryPurple10;
const bgInteractiveStrong = basePrimaryPurple100;
const bgDestructive = basePrimaryRed50;
const bgDestructiveSubtle = baseSecondarySalmon10;
const bgDestructiveStrong = basePrimaryRed100;
const bgSuccess = basePrimaryGreen100;
const bgSuccessSubtle = basePrimaryGreen10;
const bgWarning = baseTertiaryWarning100;
const bgWarningSubtle = baseSecondarySalmon10;
const bgInfo = basePrimaryCyan100;
const bgInfoSubtle = basePrimaryCyan10;
const bgDark = basePrimaryGrey80;
const bgSelectedcontrol = basePrimaryGrey10;
const bgSelectedcontrolhover = basePrimaryGrey25;
const utilityInteractive100 = basePrimaryPurple100;
const dataVizPurple100 = basePrimaryPurple100;
const utilityInteractive50 = basePrimaryPurple50;
const utilityInteractive10 = basePrimaryPurple10;
const utilityNegative100 = basePrimaryRed100;
const utilityNegative50 = basePrimaryRed50;
const utilityNegative10 = basePrimaryRed10;
const utilityPositive100 = basePrimaryGreen100;
const dataVizRed100 = basePrimaryRed100;
const utilityPositive50 = basePrimaryGreen50;
const utilityPositive10 = basePrimaryGreen10;
const dataVizFlamingo100 = baseTertiaryFlamingo100;
const utilityWarning100 = baseTertiaryWarning100;
const utilityWarning50 = baseSecondarySalmon50;
const utilityWarning10 = baseSecondarySalmon10;
const utilityInfo100 = basePrimaryCyan100;
const utilityInfo50 = basePrimaryCyan50;
const dataVizGray50 = basePrimaryGrey50;
const utilityInfo10 = basePrimaryCyan10;

export const Colors = {
    textSecondary,
    textOnColorSecondary,
    iconOnColorSubtle,
    basePrimaryGrey90,
    basePrimaryGrey80,
    basePrimaryGrey60,
    basePrimaryGrey50,
    basePrimaryGrey35,
    basePrimaryGrey25,
    basePrimaryGrey15,
    basePrimaryGrey10,
    basePrimaryGrey5,
    basePrimaryGrey1,
    basePrimaryGreyWhite,
    basePrimaryPurple100,
    basePrimaryPurple90,
    basePrimaryPurple70,
    basePrimaryPurple50,
    basePrimaryPurple20,
    baseSecondarySalmon100,
    baseSecondarySalmon50,
    baseSecondarySalmon20,
    baseSecondarySalmon10,
    baseSecondaryMustard100,
    baseSecondaryMustard50,
    baseSecondaryMustard20,
    baseSecondaryMustard10,
    basePrimaryPurple10,
    basePrimaryGreen100,
    basePrimaryGreen50,
    bgOverlayOverlayModal,
    basePrimaryGreen20,
    bgOverlayOverlayLightbox,
    bgOverlayOverlayTakeover,
    basePrimaryGreen10,
    basePrimaryRed100,
    basePrimaryRed50,
    basePrimaryRed20,
    basePrimaryRed10,
    basePrimaryCyan100,
    basePrimaryCyan50,
    basePrimaryCyan20,
    basePrimaryCyan10,
    basePrimaryGreyBlack,
    basePrimaryGreyTransparent,
    baseTertiaryMidnight100,
    baseTertiaryOcean100,
    baseTertiaryForest100,
    baseTertiarySeabreeze100,
    baseTertiaryLime100,
    baseTertiaryLemon100,
    baseTertiaryTangerine100,
    baseTertiaryFlamingo100,
    baseTertiaryCottoncandy100,
    baseTertiaryWarning100,
    baseTertiaryLavenderlighten40,
    baseTertiaryLavenderlighten100,
    baseTertiaryViolet80,
    dataVizGreen90,
    dataVizRed60,
    dataVizCyan80,
    dataVizSalmon80,
    dataVizOcean80,
    dataVizViolet80,
    dataVizForest90,
    dataVizCognac80,
    dataVizMidnight80,
    dataVizPurple60,
  /** Used to add a subtle outline by by layering a dark overlay (#000 8%) */
    borderOutlinedark,
  /** Used to add a subtle outline by by layering a light overlay (#FFFFFF 8%) */
    borderOutlinelight,
    bgOverlayDarkoverlay,
    textPrimary,
    textDisabled,
    textOnColor,
    textInteractive,
    textInteractiveHover,
    textLink,
    textDestructive,
    textSuccess,
    textWarning,
    textInfo,
    iconPrimary,
    iconPrimaryHover,
    iconSubtle,
    iconDisabled,
    iconEmphasis,
    iconOnColor,
    iconInteractive,
    iconInteractiveHover,
    iconInteractiveSubtle,
    iconDestructive,
    iconSuccess,
    iconWarning,
    iconInfo,
    iconFolder,
    borderPrimary,
    borderPrimarySubtle,
    borderStrong,
    borderEmphasis,
    borderDark,
    borderOnColor,
    borderInteractive,
    borderInteractiveSubtle,
    borderInteractiveStrong,
    borderDestructive,
    borderDestructiveSubtle,
    borderSuccess,
    borderSuccessSubtle,
    borderWarning,
    borderWarningSubtle,
    borderInfo,
    borderInfoSubtle,
    bgPrimary,
    bgPrimaryHover,
    bgSecondary,
    bgSecondaryHover,
    bgTertiary,
    bgTertiaryHover,
    bgEmphasis,
    bgDisabled,
    bgDisabledStrong,
    bgStrong,
    bgStronghover,
    bgInteractive,
    bgInteractiveStrong,
    bgDestructive,
    bgDestructiveSubtle,
    bgDestructiveStrong,
    bgSuccess,
    bgSuccessSubtle,
    bgWarning,
    bgWarningSubtle,
    bgInfo,
    bgInfoSubtle,
    bgDark,
    bgSelectedcontrol,
    bgSelectedcontrolhover,
    utilityInteractive100,
    dataVizPurple100,
    utilityInteractive50,
    utilityInteractive10,
    utilityNegative100,
    utilityNegative50,
    utilityNegative10,
    utilityPositive100,
    dataVizRed100,
    utilityPositive50,
    utilityPositive10,
    dataVizFlamingo100,
    utilityWarning100,
    utilityWarning50,
    utilityWarning10,
    utilityInfo100,
    utilityInfo50,
    dataVizGray50,
    utilityInfo10,
}